import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class DoctorsService {

  constructor(private httpRes: HttpRequestService) { }

  GetDoctors()
  {
      return this.httpRes.GetRequest(`Doctor/GetDoctors`);
  }

  GetDoctorsDisplayedAtMainPage()
  {
      return this.httpRes.GetRequest(`Doctor/GetDoctorsDisplayedAtMainPage`);
  }

  GetDoctorsBySubSpecialityId(subSpecialityId :number)
  {
      return this.httpRes.GetRequest(`Doctor/GetDoctorsBySubSpecialityId/${subSpecialityId}`);
  }

  GetDoctorById(id)
  {
      return this.httpRes.GetRequest(`Doctor/GetDoctorById/${id}`);
  }

  AddDoctor(subSpeciality: any){
    return this.httpRes.postRequest(`Doctor/AddDoctor`,subSpeciality);
  }

  DeleteDoctor(id){
    return this.httpRes.GetRequest(`Doctor/DeleteDoctor/${id}`);
  }

  UpdateDoctor(subSpeciality : any){
    return this.httpRes.postRequest(`Doctor/UpdateDoctor`,subSpeciality);
  }

  UpdateProfileImage(image: any , doctorId:any)
  {
    const formData: FormData = new FormData();
    formData.append('record',image , image.name);

      return this.httpRes.postFile(`Doctor/UpdateProfileImage/${doctorId}`, formData);
  }
}
